export const getEvents = state => state.events.events;
export const getIsLoadingEvents = state => state.events.isLoading;
export const getEventsError = state => state.events.errorMessage;
export const getEventUpsertSuccessful = state => state.events.upsertSuccessful;
export const getEventUpsertError = state => state.events.upsertError;
export const getEventDeleted = state => state.events.deleteSuccessful;
